import { ApiService } from './ApiService';

export interface NodeExecutionRecord {
  id: string;
  execId?: string;
  flowId: string;
  nodeId: string;
  type?: string;
  input?: Record<string, unknown> | null;
  outputData?: Record<string, unknown> | null;
  output?: string | null;
  outputType?: string | null;
  isError: boolean;
  metadata?: Record<string, unknown> | null;
  createdAt?: string;
  updatedAt?: string;
}

export class NodeExecutionsService extends ApiService {
  static pathName = '/node-executions';

  static getByExecAndNode = (
    execId: string,
    nodeId: string,
    signal?: AbortSignal,
  ): Promise<NodeExecutionRecord> => {
    return this.get(
      `${this.pathName}/exec/${execId}/node/${nodeId}`,
      undefined,
      signal,
    );
  };

  static getLatestByFlowAndNode = (
    flowId: string,
    nodeId: string,
    signal?: AbortSignal,
  ): Promise<NodeExecutionRecord> => {
    return this.get(
      `${this.pathName}/latest/flow/${flowId}/node/${nodeId}`,
      undefined,
      signal,
    );
  };
}
